import * as pdfjsLib from "pdfjs-dist/legacy/build/pdf";
import workerSrc from "pdfjs-dist/legacy/build/pdf.worker.entry";

pdfjsLib.GlobalWorkerOptions.workerSrc = workerSrc;

// Çok sayfalı raporda tuvalin sınırsız büyümesini engelliyoruz; tarayıcıların
// canvas yükseklik sınırı var ve çok büyük PNG'ler bellekte sorun çıkarıyor.
const MAX_TOTAL_HEIGHT = 16000;
const PAGE_GAP = 16;

/**
 * PDF blob'unu tek bir PNG'ye çevirir: sayfalar alt alta birleştirilir.
 * Kaynak, önizlemede gösterilen belgenin ta kendisi olduğu için PNG ile PDF
 * birebir aynı görünür.
 *
 * @param {Blob} blob PDF içeriği
 * @param {{scale?: number}} options çözünürlük çarpanı (varsayılan 2)
 * @returns {Promise<Blob>} PNG blob
 */
export async function pdfBlobToPngBlob(blob, { scale = 2 } = {}) {
  const buffer = await blob.arrayBuffer();
  const doc = await pdfjsLib.getDocument({ data: buffer }).promise;

  try {
    const pages = [];
    let totalHeight = 0;
    let width = 0;

    for (let pageNumber = 1; pageNumber <= doc.numPages; pageNumber += 1) {
      // eslint-disable-next-line no-await-in-loop
      const page = await doc.getPage(pageNumber);
      const viewport = page.getViewport({ scale });
      const nextHeight = totalHeight + viewport.height + (pages.length ? PAGE_GAP : 0);
      if (pages.length && nextHeight > MAX_TOTAL_HEIGHT) {
        page.cleanup();
        break;
      }
      pages.push({ page, viewport });
      totalHeight = nextHeight;
      width = Math.max(width, viewport.width);
    }

    if (pages.length === 0) throw new Error("PDF sayfası bulunamadı");

    const canvas = document.createElement("canvas");
    canvas.width = Math.ceil(width);
    canvas.height = Math.ceil(totalHeight);
    const context = canvas.getContext("2d");
    context.fillStyle = "#FFFFFF";
    context.fillRect(0, 0, canvas.width, canvas.height);

    let offsetY = 0;
    for (const { page, viewport } of pages) {
      const pageCanvas = document.createElement("canvas");
      pageCanvas.width = Math.ceil(viewport.width);
      pageCanvas.height = Math.ceil(viewport.height);
      // eslint-disable-next-line no-await-in-loop
      await page.render({ canvasContext: pageCanvas.getContext("2d"), viewport }).promise;
      context.drawImage(pageCanvas, 0, offsetY);
      offsetY += viewport.height + PAGE_GAP;
      page.cleanup();
    }

    return await new Promise((resolve, reject) => {
      canvas.toBlob((result) => {
        if (result) resolve(result);
        else reject(new Error("PNG üretilemedi"));
      }, "image/png");
    });
  } finally {
    doc.destroy();
  }
}

/** `Rapor.pdf` → `Rapor.png` */
export function pngFileName(pdfFileName) {
  return String(pdfFileName || "rapor.pdf").replace(/\.pdf$/i, "") + ".png";
}
